import { useMemo } from "react"
import { IconButton, Skeleton, Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { MeetingHeader } from "./MeetingHeader"
import { MeetingDetails } from "./MeetingDetails"
import { GuestsSection } from "./GuestsSection"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faXmarkCircle } from "@fortawesome/pro-light-svg-icons"
import { MeetingDetailsOrder } from "../../meetings/meetingTypes"
import { ServiceCenterBooking } from "../../serviceCenterHomeTypes"
import { resolveExternalAttendees, resolveMeetingHostId } from "./meetingAttendees"

const useStyles = makeStyles()(() => ({
    container: {
        width: "100%",
        padding: ".5rem 2rem",
    },
}))

type MeetingContentProps = {
    meetingData?: MeetingDetailsOrder
    orderId?: number
    onClose: () => void
    meetings?: ServiceCenterBooking[]
    isLoading: boolean
}

export function MeetingContent({ onClose, meetings, meetingData, orderId, isLoading }: MeetingContentProps) {
    const { classes } = useStyles()

    const guests = useMemo(() => resolveExternalAttendees(meetingData), [meetingData])
    const hostId = useMemo(() => resolveMeetingHostId(meetingData), [meetingData])

    return (
        <Stack className={classes.container} spacing="2rem">
            <Stack spacing="1rem">
                <Stack alignItems="end">
                    <IconButton onClick={onClose} sx={{ marginRight: "-1.5rem" }}>
                        <FontAwesomeIcon icon={faXmarkCircle} />
                    </IconButton>
                </Stack>
                <MeetingHeader meetingData={meetingData} meetings={meetings} orderId={orderId} onClose={onClose} />
                <MeetingDetails
                    organizers={meetingData?.organizers}
                    companyName={meetingData?.accountingCustomerParty?.name}
                    time={meetingData?.meetingDetails.meetingTimeAsText}
                    location={meetingData?.meetingDetails.location}
                />
            </Stack>

            {isLoading ? (
                <Stack gap="4rem">
                    <Stack gap="1rem">
                        <Skeleton variant="rectangular" animation="wave" width="65%" height={28} />
                        <Skeleton variant="rectangular" animation="wave" height={56} />
                        <Skeleton variant="rectangular" animation="wave" height={56} />
                    </Stack>
                    <Stack gap="1rem">
                        <Skeleton variant="rectangular" animation="wave" width="65%" height={28} />
                        <Skeleton variant="rectangular" animation="wave" height={56} />
                        <Skeleton variant="rectangular" animation="wave" height={56} />
                    </Stack>
                </Stack>
            ) : (
                <GuestsSection guests={guests} hostId={hostId} />
            )}
        </Stack>
    )
}
